module.exports = __webpack_public_path__ + "static/directors4-97cc3df1eef122625a52841e6887ae2b.jpg";